import clsx from 'clsx';
import { IAnyType } from 'common/types/common';

export const Input = ({
  className,
  label,
  value,
  onChange,
  onBlur,
  name,
  required,
  errorMessage,
  disabled,
  type = 'text',
  isValid,
}: IAnyType) => {
  return (
    <div className={clsx('mb-3 w-full', className)}>
      <div className="relative w-full">
        <input
          type={type}
          id={name}
          value={value}
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          placeholder=" "
          disabled={disabled}
          className={clsx(
            'autofill-transparent focus:ring-0; peer block h-[68px] w-full rounded-lg border border-neutral-300 bg-[#1C1027] px-3 pb-3 pr-12 pt-6 text-white focus:border-primary focus:outline-none',
            { 'input-error': !!errorMessage, 'input-success': isValid },
          )}
        />
        <label
          htmlFor={name}
          dangerouslySetInnerHTML={{ __html: `${required ? '*' : ''} ${label}` }}
          className="text-md absolute left-1 top-4 z-10 origin-[0] -translate-y-4 scale-[0.6] transform bg-[#1C1027] pl-5 pr-4 font-normal text-[#ffffff!important] opacity-90 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-4 peer-focus:-translate-y-4 peer-focus:scale-[0.6] peer-focus:px-4"
        />
      </div>

      {!!errorMessage && (
        <div className="ml-2 mt-1.5 text-xs text-red-600">{errorMessage || 'Message'}</div>
      )}
    </div>
  );
};
